export default __webpack_public_path__ + "static/media/gallery-13-4.2dd0a000.webp";